import TimestampManagerComponent from './TimestampManagerComponent';
export default TimestampManagerComponent;
